import { Disposer } from "../Infra/Disposer";
export class FacilitatedFHIRLoginViewModel {
    constructor(container) {
        this.container = container;
        this.disposer = new Disposer();
        this.facilitatedFHIRAuthManager = container.facilitatedFHIRAuthManager;
    }
    run() {
        this.disposer.reaction(() => this.facilitatedFHIRAuthManager.state, () => {
            if (this.facilitatedFHIRAuthManager.hasCompletedAuth) {
                const authData = this.facilitatedFHIRAuthManager.getFacilitatedFHIRAuthData();
                if (!authData) {
                    return;
                }
                window.location.hash = authData.callbackHash;
                this.facilitatedFHIRAuthManager.setFacilitatedFHIRAuthData(null);
            }
        }, { fireImmediately: true, name: "FacilitatedFHIRLoginViewModel_facilitatedFHIRAuthManagerState" });
    }
    stop() {
        this.disposer.dispose();
    }
}
